import { render, staticRenderFns } from "./PopupBox.vue?vue&type=template&id=17c5f1b8&scoped=true&"
import script from "./PopupBox.vue?vue&type=script&lang=js&"
export * from "./PopupBox.vue?vue&type=script&lang=js&"
import style0 from "./PopupBox.vue?vue&type=style&index=0&id=17c5f1b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17c5f1b8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('17c5f1b8')) {
      api.createRecord('17c5f1b8', component.options)
    } else {
      api.reload('17c5f1b8', component.options)
    }
    module.hot.accept("./PopupBox.vue?vue&type=template&id=17c5f1b8&scoped=true&", function () {
      api.rerender('17c5f1b8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-22M0Ip99fHjKm/JS/comp/PopupBox.vue"
export default component.exports